/** Floating popover material (menus, listboxes, pickers). Positioning, width, padding and z-index stay with each caller. */
export const popoverSurfaceClassName = 'rounded-lg border border-neutral-200 bg-white shadow-lg';

/** Neutral menu row: visible hover and pressed fills on the popover material. */
export const menuItemClassName =
    'flex min-h-9 w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-neutral-700 transition-colors hover:bg-neutral-100 active:bg-neutral-200 focus-visible:outline-none focus-visible:bg-neutral-100 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring disabled:cursor-not-allowed disabled:text-neutral-400 disabled:hover:bg-transparent';

export const menuItemDestructiveClassName =
    'font-medium text-destructive hover:bg-red-50 active:bg-red-100 focus-visible:bg-red-50 disabled:text-neutral-500';

export const menuSeparatorClassName = 'my-1 h-px bg-neutral-200';
